import { AtFaultDriverQueryResponseType } from '@/common/queries/selections/atFaultDriver/atFaultDriverQuery.type.ts';
import { fetchApi } from '@/config/axiosSetting';



export const atFaultDriverQueryFunction = (): Promise<
  AtFaultDriverQueryResponseType[]
> => {
  return fetchApi.get('selection_item/at_fault_driver/wop_list/');
};
